import { Breed } from "../Breed.js";
import { Locale, type LocalizedString } from "../Locale.js";

export const breedNameMap: Record<Breed, LocalizedString> = {
	[Breed.Mixed]: {
		[Locale.cs]: "Mix",
		[Locale.en]: "Mixed",
	},
	[Breed.AmericanStaffordshireTerrier]: {
		[Locale.cs]: "Americký stafordšírský teriér",
		[Locale.en]: "American Staffordshire Terrier",
	},
	[Breed.AustralianCattledog]: {
		[Locale.cs]: "Australský honácký pes",
		[Locale.en]: "Australian Cattledog",
	},
	[Breed.AustralianKelpie]: {
		[Locale.cs]: "Australská kelpie",
		[Locale.en]: "Australian Kelpie",
	},
	[Breed.AustralianShepherd]: {
		[Locale.cs]: "Australský ovčák",
		[Locale.en]: "Australian Shepherd",
	},
	[Breed.Bauceron]: {
		[Locale.cs]: "Bauceron",
		[Locale.en]: "Bauceron",
	},
	[Breed.BergerdesPyrenees]: {
		[Locale.cs]: "Pyrenejský ovčák",
		[Locale.en]: "Berger des Pyrénées",
	},
	[Breed.BohemianShepherd]: {
		[Locale.cs]: "Chodský pes",
		[Locale.en]: "Bohemian Shepherd",
	},
	[Breed.BorderColie]: {
		[Locale.cs]: "Border kolie",
		[Locale.en]: "Border Colie",
	},
	[Breed.BorderTerrier]: {
		[Locale.cs]: "Border teriér",
		[Locale.en]: "Border Terrier",
	},
	[Breed.Boxer]: {
		[Locale.cs]: "Boxer",
		[Locale.en]: "Boxer",
	},
	[Breed.ChiendeBergerBelgeMalinois]: {
		[Locale.cs]: "Belgický ovčák malinois",
		[Locale.en]: "Chien de Berger Belge - Malinois",
	},
	[Breed.ChiendeBergerBelgeTervueren]: {
		[Locale.cs]: "Belgický ovčák tervueren",
		[Locale.en]: "Chien de Berger Belge - Tervueren",
	},
	[Breed.Dobermann]: {
		[Locale.cs]: "Dobrman",
		[Locale.en]: "Dobermann",
	},
	[Breed.EnglishSetter]: {
		[Locale.cs]: "Irský setr",
		[Locale.en]: "English Setter",
	},
	[Breed.FoxTerier]: {
		[Locale.cs]: "Foxteriér",
		[Locale.en]: "Fox Terier",
	},
	[Breed.GermanShepherd]: {
		[Locale.cs]: "Německý ovčák",
		[Locale.en]: "GermanShepherd",
	},
	[Breed.GoldenRetriever]: {
		[Locale.cs]: "Zlatý retrívr",
		[Locale.en]: "Golden Retriever",
	},
	[Breed.HollandseHerdershond]: {
		[Locale.cs]: "Holandský ovčák",
		[Locale.en]: "Hollandse Herdershond",
	},
	[Breed.JackRusselTerrier]: {
		[Locale.cs]: "Jack russel teriér",
		[Locale.en]: "Jack Russel Terrier",
	},
	[Breed.Kooikerhondje]: {
		[Locale.cs]: "Kooikerhondje",
		[Locale.en]: "Kooikerhondje",
	},
	[Breed.LabradorRetriever]: {
		[Locale.cs]: "Labrador",
		[Locale.en]: "Labrador Retriever",
	},
	[Breed.LouisianaCatahoula]: {
		[Locale.cs]: "Lousianský leopardí pes",
		[Locale.en]: "Louisiana Catahoula",
	},
	[Breed.MiniatureAmericanShepherd]: {
		[Locale.cs]: "Miniaturní australský ovčák",
		[Locale.en]: "Miniature American Shepherd",
	},
	[Breed.Mudi]: {
		[Locale.cs]: "Mudi",
		[Locale.en]: "Mudi",
	},
	[Breed.Novascottiaducktollinretriever]: {
		[Locale.cs]: "Kanadský retrívr",
		[Locale.en]: "Nova scottia duck tollin retriever",
	},
	[Breed.ParsonRussellTerrier]: {
		[Locale.cs]: "Parson russell teriér",
		[Locale.en]: "Parson Russell Terrier",
	},
	[Breed.Pitbull]: {
		[Locale.cs]: "Pitbull",
		[Locale.en]: "Pitbull",
	},
	[Breed.Rhodesianridgeback]: {
		[Locale.cs]: "Rhodézský ridgeback",
		[Locale.en]: "Rhodesian ridgeback",
	},
	[Breed.Rottweiler]: {
		[Locale.cs]: "Rotvajler",
		[Locale.en]: "Rottweiler",
	},
	[Breed.RoughCollie]: {
		[Locale.cs]: "Dlouhostrstá kolie",
		[Locale.en]: "Rough Collie",
	},
	[Breed.RovidszoruMagyarViszla]: {
		[Locale.cs]: "Maďarský ohař krátkosrstý",
		[Locale.en]: "Rövidszörü Magyar Viszla",
	},
	[Breed.Saluki]: {
		[Locale.cs]: "Saluki",
		[Locale.en]: "Saluki",
	},
	[Breed.Sheltie]: {
		[Locale.cs]: "Šeltie",
		[Locale.en]: "Sheltie",
	},
	[Breed.StaffordshireBullterrier]: {
		[Locale.cs]: "Stafordšírský bulterier",
		[Locale.en]: "Staffordshire Bullterrier",
	},
	[Breed.WelshCorgi]: {
		[Locale.cs]: "Welsh Corgi",
		[Locale.en]: "Welsh Corgi",
	},
	[Breed.Whippet]: {
		[Locale.cs]: "Vipet",
		[Locale.en]: "Whippet",
	},
};
